export default "__VITE_PUBLIC_ASSET__ffb9be0d__"